import React from 'react';
import styled from 'styled-components';
import { ButtonLink } from 'next/components/ui';

const CardLink = props => {
  const { addCard, userWithAccountId } = props;

  return (
    <LinkWrapper>
      <p>
        You can{' '}
        <ButtonLink
          className="saveCreditCardLink"
          onClick={() => addCard(userWithAccountId)}
        >
          save a credit card
        </ButtonLink>{' '}
        to use at a later time with your subscription.
      </p>
    </LinkWrapper>
  );
};

export default CardLink;

const LinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  color: ${props => props.theme['$gray-30']};
`;
